import React, { FC } from 'react'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { ListItem } from '@ucheba/ui/components/List/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import dayjs from '@ucheba/utils/helpers/date/dayjs'
import { INewsItemProps } from '../types'

const NewsItem: FC<INewsItemProps> = (props) => {
  const { isDivider = true, dateCreated, title, path } = props

  const date =
    new Date(dateCreated).getFullYear() !== new Date().getFullYear()
      ? dayjs(dateCreated).format('DD MMMM YYYY')
      : dayjs(dateCreated).format('DD MMMM')

  return (
    <ListItem>
      {isDivider && <Divider spacing='null' />}

      <Spacing spacing='xlarge' />

      <Text fontSize='h5' lineHeight='h4' fontWeight='semibold'>
        {date}
      </Text>

      <Spacing spacing='usmall' />

      <a href={path}>
        <Text color='blue' fontSize='h3' lineHeight='h3' fontWeight='bold'>
          {title}
        </Text>
      </a>

      <Spacing spacing='xlarge' />
    </ListItem>
  )
}

export default NewsItem
